<template>
  <div class="us-nav-wrap">
    <div class="us-nav-inner">
      <div class="navbar-left">
        <div class="logo-wrap" @click="onGo('/home')">
          <img class="sys-title mini" src="@/assets/sys-title1.png">
          <img class="sys-title pc" src="@/assets/sys-title.png">
          <img class="logo" src="@/assets/logo.png">
        </div>
      </div>
      <div class="navbar-right">
        <div class="right-more-row">
          <div v-if="!getUserName" class="right-item" @click="onLogin">Sign In</div>
          <template v-else>
            <div class="right-item">{{ getUserNameEn || getUserName }}</div>
            <el-tooltip class="item" effect="dark" content="Logout" placement="bottom">
              <div class="right-item" @click="onLoginOut">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </template>
        </div>
      </div>
    </div>
    <login-form ref="loginForm" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import LoginForm from '_c/login-form'

export default {
  name: 'nav-bar',
  components: { LoginForm },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'getUserName',
      'getUserNameEn',
    ]),
  },
  mounted() {
    
  },
  methods: {
    ...mapActions({
      actionLoginOut: 'userLogout'
    }),
    onGo(tag) {
      if (this.$route.path != tag) {
        this.$router.push(tag)
      }
    },
    onLogin() {
      this.$refs.loginForm.show()
    },
    onLoginOut() {
      this.$confirm('Sure to log out?', 'Log Out', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async () => {
        const ret = await this.actionLoginOut()
        if (ret.code === 0) {
          if (this.$route.name != 'home') {
            this.$router.push('/home');
          } else {
            window.location.reload()
          }
        }
      }).catch(() => { })
    }
  }
}
</script>

<style lang="less" scoped>
@splitColor: #eee;

.us-nav-wrap {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  font-size: 15px;
  height: @usNavHeight;
  overflow: visible;
  color: #1a1a1a;
  background-color: #fff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);


  .us-nav-inner {
    width: auto;
    max-width: @pageContentWidth;
    height: @usNavHeight;
    
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;
    

    .navbar-left {
      .logo-wrap {
        cursor: pointer;
        display: flex;
        align-items: center;
        img {
          height: 50px;
        }
        .sys-title {
          &.pc {
            display: block;
          }
          &.mini {
            display: none;
          }
        }
        .logo {
          height: 46px;
          margin: 2px 0;
        }
      }
    }

    .navbar-right {
      display: flex;
      align-items: center;
      height: 100%;
      .right-more-row {
        display: flex;
        align-items: center;
        height: 100%;
        .right-item {
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 10px;
          font-size: 14px;
          cursor: pointer;
          font-weight: 600;

          &:hover {
            background-color: @splitColor;
          }
        }

        .line {
          height: 40px;
          width: 2px;
          margin: 0 10px;
          background-color: @themeColor1;
        }

      }
    }
  }
}

@media screen and (max-width: @xsW) {
.us-nav-wrap {
  width: 100%;


  .us-nav-inner {
    width: 100%;
    .navbar-left {
      .logo-wrap {
        cursor: pointer;
        img {
          height: 50px;
        }
        .logo {
          // display: none;
          height: 40px;
          margin: 5px 0;
        }
        .sys-title {
          &.pc {
            display: none;
          }
          &.mini {
            display: block;
          }
        }
      }
    }
  }
}
}
</style>
